/* src/modules/create_tutor/cards/CreateMultipleTutorsCard/styles.js */

export default theme => ({
  title: {
    margin: theme.spacing.unit * 3,
    marginTop: 0,
    marginBottom: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit * 3,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
  progress: {
    // marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
  spacing: {
    height: theme.spacing.unit * 3,
  },
  fileInformation: {
    marginLeft: theme.spacing.unit * 3,
  },
  header: {
    margin: theme.spacing.unit * 3,
    marginBottom: 0,
  },
  greenText: {
    color: 'green',
  },
  tableContainer: {
    height: theme.spacing.unit * 32,
    overflow: 'auto',
  },
  orgText: {
    marginLeft: theme.spacing.unit * 3,
  },
  instructions: {
    marginLeft: theme.spacing.unit * 6,
    marginRight: theme.spacing.unit * 6,
  },
});



// WEBPACK FOOTER //
// ./src/modules/create_tutor/cards/CreateMultipleTutorsCard/styles.js